import { render, staticRenderFns } from "./FinalizationModal.vue?vue&type=template&id=690a5b09&scoped=true"
import script from "./FinalizationModal.vue?vue&type=script&lang=js"
export * from "./FinalizationModal.vue?vue&type=script&lang=js"
import style0 from "./FinalizationModal.vue?vue&type=style&index=0&id=690a5b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a5b09",
  null
  
)

export default component.exports